/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as partnerPartnerRouteImport } from './routes/(partner)/_partner'
import { Route as dashboardDashboardRouteImport } from './routes/(dashboard)/_dashboard'
import { Route as authAuthRouteImport } from './routes/(auth)/_auth'
import { Route as adminAdminRouteImport } from './routes/(admin)/_admin'
import { Route as partnerPartnerSingleInterviewRouteImport } from './routes/(partner)/_partner.single-interview'
import { Route as partnerPartnerReviewModeOldRouteImport } from './routes/(partner)/_partner.review-mode-old'
import { Route as partnerPartnerReviewModeRouteImport } from './routes/(partner)/_partner.review-mode'
import { Route as partnerPartnerQuestionSelectorRouteImport } from './routes/(partner)/_partner.question-selector'
import { Route as partnerPartnerPartnerReviewModeRouteImport } from './routes/(partner)/_partner.partner-review-mode'
import { Route as partnerPartnerInviteUserRouteImport } from './routes/(partner)/_partner.invite-user'
import { Route as partnerPartnerInterviewOverviewRouteImport } from './routes/(partner)/_partner.interview-overview'
import { Route as partnerPartnerInterviewGeneratorStep1RouteImport } from './routes/(partner)/_partner.interview-generator-step1'
import { Route as partnerPartnerInterviewGenaratorStep2RouteImport } from './routes/(partner)/_partner.interview-genarator-step2'
import { Route as partnerPartnerInterviewFromScratchRouteImport } from './routes/(partner)/_partner.interview-from-scratch'
import { Route as partnerPartnerInterviewDurationRouteImport } from './routes/(partner)/_partner.interview-duration'
import { Route as partnerPartnerCreatedInterviewsRouteImport } from './routes/(partner)/_partner.created-interviews'
import { Route as partnerPartnerCreateInterviewStep2RouteImport } from './routes/(partner)/_partner.create-interview-step2'
import { Route as partnerPartnerCreateInterviewStep1RouteImport } from './routes/(partner)/_partner.create-interview-step1'
import { Route as dashboardDashboardTechnologiesRouteImport } from './routes/(dashboard)/_dashboard.technologies'
import { Route as dashboardDashboardProfileRouteImport } from './routes/(dashboard)/_dashboard.profile'
import { Route as dashboardDashboardJobDescriptionRouteImport } from './routes/(dashboard)/_dashboard.job-description'
import { Route as dashboardDashboardHistoryRouteImport } from './routes/(dashboard)/_dashboard.history'
import { Route as dashboardDashboardCustomizeInterviewRouteImport } from './routes/(dashboard)/_dashboard.customize-interview'
import { Route as dashboardDashboardCreditsRouteImport } from './routes/(dashboard)/_dashboard.credits'
import { Route as authAuthResetPasswordRouteImport } from './routes/(auth)/_auth.reset-password'
import { Route as authAuthRegisterRouteImport } from './routes/(auth)/_auth.register'
import { Route as authAuthLoginRouteImport } from './routes/(auth)/_auth.login'
import { Route as authAuthForgotPasswordRouteImport } from './routes/(auth)/_auth.forgot-password'
import { Route as authAuthConfirmEmailRouteImport } from './routes/(auth)/_auth.confirm-email'
import { Route as authAuthAccountVerifiedRouteImport } from './routes/(auth)/_auth.account-verified'
import { Route as adminAdminInviteRouteImport } from './routes/(admin)/_admin.invite'
import { Route as adminAdminCreateTechnologyRouteImport } from './routes/(admin)/_admin.create-technology'
import { Route as adminAdminCreateInterviewRouteImport } from './routes/(admin)/_admin.create-interview'
import { Route as adminAdminCreateCategoryOldRouteImport } from './routes/(admin)/_admin.create-category-old'
import { Route as adminAdminCreateCategoryRouteImport } from './routes/(admin)/_admin.create-category'
import { Route as adminAdminAdminInterviewFromScratchRouteImport } from './routes/(admin)/_admin.admin-interview-from-scratch'
import { Route as adminAdminAdminDashboardRouteImport } from './routes/(admin)/_admin.admin-dashboard'
import { Route as adminAdminAdminCreateInterviewStep2RouteImport } from './routes/(admin)/_admin.admin-create-interview-step-2'
import { Route as adminAdminAdminCompaniesRouteImport } from './routes/(admin)/_admin.admin-companies'
import { Route as adminAdminAdminAdvancedInterviewGeneratorStep2RouteImport } from './routes/(admin)/_admin.admin-advanced-interview-generator-step-2'
import { Route as adminAdminAdminAdvancedInterviewGeneratorStep1RouteImport } from './routes/(admin)/_admin.admin-advanced-interview-generator-step-1'
import { Route as dashboardDashboardResultsOverviewIdRouteImport } from './routes/(dashboard)/_dashboard.results-overview.$id'
import { Route as dashboardDashboardQuestionsIdRouteImport } from './routes/(dashboard)/_dashboard.questions.$id'
import { Route as dashboardDashboardProfilePasswordRouteImport } from './routes/(dashboard)/_dashboard.profile.password'
import { Route as dashboardDashboardProfileInfoRouteImport } from './routes/(dashboard)/_dashboard.profile.info'
import { Route as dashboardDashboardHistoryDetailsIdRouteImport } from './routes/(dashboard)/_dashboard.history-details.$id'
import { Route as adminAdminTechnologyIdRouteImport } from './routes/(admin)/_admin.technology.$id'
import { Route as dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRouteImport } from './routes/(dashboard)/_dashboard.history-category-detail.$interviewId.$categoryId'

const partnerRouteImport = createFileRoute('/(partner)')()
const dashboardRouteImport = createFileRoute('/(dashboard)')()
const authRouteImport = createFileRoute('/(auth)')()
const adminRouteImport = createFileRoute('/(admin)')()
const IndexLazyRouteImport = createFileRoute('/')()

const partnerRoute = partnerRouteImport.update({
  id: '/(partner)',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardRoute = dashboardRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRoute = authRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const adminRoute = adminRouteImport.update({
  id: '/(admin)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const partnerPartnerRoute = partnerPartnerRouteImport.update({
  id: '/_partner',
  getParentRoute: () => partnerRoute,
} as any)
const dashboardDashboardRoute = dashboardDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => dashboardRoute,
} as any)
const authAuthRoute = authAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => authRoute,
} as any)
const adminAdminRoute = adminAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => adminRoute,
} as any)
const partnerPartnerSingleInterviewRoute =
  partnerPartnerSingleInterviewRouteImport.update({
    id: '/single-interview',
    path: '/single-interview',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerReviewModeOldRoute =
  partnerPartnerReviewModeOldRouteImport.update({
    id: '/review-mode-old',
    path: '/review-mode-old',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerReviewModeRoute =
  partnerPartnerReviewModeRouteImport.update({
    id: '/review-mode',
    path: '/review-mode',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerQuestionSelectorRoute =
  partnerPartnerQuestionSelectorRouteImport.update({
    id: '/question-selector',
    path: '/question-selector',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerPartnerReviewModeRoute =
  partnerPartnerPartnerReviewModeRouteImport.update({
    id: '/partner-review-mode',
    path: '/partner-review-mode',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerInviteUserRoute =
  partnerPartnerInviteUserRouteImport.update({
    id: '/invite-user',
    path: '/invite-user',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerInterviewOverviewRoute =
  partnerPartnerInterviewOverviewRouteImport.update({
    id: '/interview-overview',
    path: '/interview-overview',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerInterviewGeneratorStep1Route =
  partnerPartnerInterviewGeneratorStep1RouteImport.update({
    id: '/interview-generator-step1',
    path: '/interview-generator-step1',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerInterviewGenaratorStep2Route =
  partnerPartnerInterviewGenaratorStep2RouteImport.update({
    id: '/interview-genarator-step2',
    path: '/interview-genarator-step2',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerInterviewFromScratchRoute =
  partnerPartnerInterviewFromScratchRouteImport.update({
    id: '/interview-from-scratch',
    path: '/interview-from-scratch',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerInterviewDurationRoute =
  partnerPartnerInterviewDurationRouteImport.update({
    id: '/interview-duration',
    path: '/interview-duration',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerCreatedInterviewsRoute =
  partnerPartnerCreatedInterviewsRouteImport.update({
    id: '/created-interviews',
    path: '/created-interviews',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerCreateInterviewStep2Route =
  partnerPartnerCreateInterviewStep2RouteImport.update({
    id: '/create-interview-step2',
    path: '/create-interview-step2',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const partnerPartnerCreateInterviewStep1Route =
  partnerPartnerCreateInterviewStep1RouteImport.update({
    id: '/create-interview-step1',
    path: '/create-interview-step1',
    getParentRoute: () => partnerPartnerRoute,
  } as any)
const dashboardDashboardTechnologiesRoute =
  dashboardDashboardTechnologiesRouteImport.update({
    id: '/technologies',
    path: '/technologies',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardProfileRoute =
  dashboardDashboardProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardJobDescriptionRoute =
  dashboardDashboardJobDescriptionRouteImport.update({
    id: '/job-description',
    path: '/job-description',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHistoryRoute =
  dashboardDashboardHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardCustomizeInterviewRoute =
  dashboardDashboardCustomizeInterviewRouteImport.update({
    id: '/customize-interview',
    path: '/customize-interview',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardCreditsRoute =
  dashboardDashboardCreditsRouteImport.update({
    id: '/credits',
    path: '/credits',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const authAuthResetPasswordRoute = authAuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthRegisterRoute = authAuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthLoginRoute = authAuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthForgotPasswordRoute = authAuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthConfirmEmailRoute = authAuthConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => authAuthRoute,
} as any)
const authAuthAccountVerifiedRoute = authAuthAccountVerifiedRouteImport.update({
  id: '/account-verified',
  path: '/account-verified',
  getParentRoute: () => authAuthRoute,
} as any)
const adminAdminInviteRoute = adminAdminInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => adminAdminRoute,
} as any)
const adminAdminCreateTechnologyRoute =
  adminAdminCreateTechnologyRouteImport.update({
    id: '/create-technology',
    path: '/create-technology',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminCreateInterviewRoute =
  adminAdminCreateInterviewRouteImport.update({
    id: '/create-interview',
    path: '/create-interview',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminCreateCategoryOldRoute =
  adminAdminCreateCategoryOldRouteImport.update({
    id: '/create-category-old',
    path: '/create-category-old',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminCreateCategoryRoute =
  adminAdminCreateCategoryRouteImport.update({
    id: '/create-category',
    path: '/create-category',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminAdminInterviewFromScratchRoute =
  adminAdminAdminInterviewFromScratchRouteImport.update({
    id: '/admin-interview-from-scratch',
    path: '/admin-interview-from-scratch',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminAdminDashboardRoute =
  adminAdminAdminDashboardRouteImport.update({
    id: '/admin-dashboard',
    path: '/admin-dashboard',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminAdminCreateInterviewStep2Route =
  adminAdminAdminCreateInterviewStep2RouteImport.update({
    id: '/admin-create-interview-step-2',
    path: '/admin-create-interview-step-2',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminAdminCompaniesRoute =
  adminAdminAdminCompaniesRouteImport.update({
    id: '/admin-companies',
    path: '/admin-companies',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminAdminAdvancedInterviewGeneratorStep2Route =
  adminAdminAdminAdvancedInterviewGeneratorStep2RouteImport.update({
    id: '/admin-advanced-interview-generator-step-2',
    path: '/admin-advanced-interview-generator-step-2',
    getParentRoute: () => adminAdminRoute,
  } as any)
const adminAdminAdminAdvancedInterviewGeneratorStep1Route =
  adminAdminAdminAdvancedInterviewGeneratorStep1RouteImport.update({
    id: '/admin-advanced-interview-generator-step-1',
    path: '/admin-advanced-interview-generator-step-1',
    getParentRoute: () => adminAdminRoute,
  } as any)
const dashboardDashboardResultsOverviewIdRoute =
  dashboardDashboardResultsOverviewIdRouteImport.update({
    id: '/results-overview/$id',
    path: '/results-overview/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardQuestionsIdRoute =
  dashboardDashboardQuestionsIdRouteImport.update({
    id: '/questions/$id',
    path: '/questions/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardProfilePasswordRoute =
  dashboardDashboardProfilePasswordRouteImport.update({
    id: '/password',
    path: '/password',
    getParentRoute: () => dashboardDashboardProfileRoute,
  } as any)
const dashboardDashboardProfileInfoRoute =
  dashboardDashboardProfileInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => dashboardDashboardProfileRoute,
  } as any)
const dashboardDashboardHistoryDetailsIdRoute =
  dashboardDashboardHistoryDetailsIdRouteImport.update({
    id: '/history-details/$id',
    path: '/history-details/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const adminAdminTechnologyIdRoute = adminAdminTechnologyIdRouteImport.update({
  id: '/technology/$id',
  path: '/technology/$id',
  getParentRoute: () => adminAdminRoute,
} as any)
const dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute =
  dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRouteImport.update(
    {
      id: '/history-category-detail/$interviewId/$categoryId',
      path: '/history-category-detail/$interviewId/$categoryId',
      getParentRoute: () => dashboardDashboardRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof partnerPartnerRouteWithChildren
  '/admin-advanced-interview-generator-step-1': typeof adminAdminAdminAdvancedInterviewGeneratorStep1Route
  '/admin-advanced-interview-generator-step-2': typeof adminAdminAdminAdvancedInterviewGeneratorStep2Route
  '/admin-companies': typeof adminAdminAdminCompaniesRoute
  '/admin-create-interview-step-2': typeof adminAdminAdminCreateInterviewStep2Route
  '/admin-dashboard': typeof adminAdminAdminDashboardRoute
  '/admin-interview-from-scratch': typeof adminAdminAdminInterviewFromScratchRoute
  '/create-category': typeof adminAdminCreateCategoryRoute
  '/create-category-old': typeof adminAdminCreateCategoryOldRoute
  '/create-interview': typeof adminAdminCreateInterviewRoute
  '/create-technology': typeof adminAdminCreateTechnologyRoute
  '/invite': typeof adminAdminInviteRoute
  '/account-verified': typeof authAuthAccountVerifiedRoute
  '/confirm-email': typeof authAuthConfirmEmailRoute
  '/forgot-password': typeof authAuthForgotPasswordRoute
  '/login': typeof authAuthLoginRoute
  '/register': typeof authAuthRegisterRoute
  '/reset-password': typeof authAuthResetPasswordRoute
  '/credits': typeof dashboardDashboardCreditsRoute
  '/customize-interview': typeof dashboardDashboardCustomizeInterviewRoute
  '/history': typeof dashboardDashboardHistoryRoute
  '/job-description': typeof dashboardDashboardJobDescriptionRoute
  '/profile': typeof dashboardDashboardProfileRouteWithChildren
  '/technologies': typeof dashboardDashboardTechnologiesRoute
  '/create-interview-step1': typeof partnerPartnerCreateInterviewStep1Route
  '/create-interview-step2': typeof partnerPartnerCreateInterviewStep2Route
  '/created-interviews': typeof partnerPartnerCreatedInterviewsRoute
  '/interview-duration': typeof partnerPartnerInterviewDurationRoute
  '/interview-from-scratch': typeof partnerPartnerInterviewFromScratchRoute
  '/interview-genarator-step2': typeof partnerPartnerInterviewGenaratorStep2Route
  '/interview-generator-step1': typeof partnerPartnerInterviewGeneratorStep1Route
  '/interview-overview': typeof partnerPartnerInterviewOverviewRoute
  '/invite-user': typeof partnerPartnerInviteUserRoute
  '/partner-review-mode': typeof partnerPartnerPartnerReviewModeRoute
  '/question-selector': typeof partnerPartnerQuestionSelectorRoute
  '/review-mode': typeof partnerPartnerReviewModeRoute
  '/review-mode-old': typeof partnerPartnerReviewModeOldRoute
  '/single-interview': typeof partnerPartnerSingleInterviewRoute
  '/technology/$id': typeof adminAdminTechnologyIdRoute
  '/history-details/$id': typeof dashboardDashboardHistoryDetailsIdRoute
  '/profile/info': typeof dashboardDashboardProfileInfoRoute
  '/profile/password': typeof dashboardDashboardProfilePasswordRoute
  '/questions/$id': typeof dashboardDashboardQuestionsIdRoute
  '/results-overview/$id': typeof dashboardDashboardResultsOverviewIdRoute
  '/history-category-detail/$interviewId/$categoryId': typeof dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof partnerPartnerRouteWithChildren
  '/admin-advanced-interview-generator-step-1': typeof adminAdminAdminAdvancedInterviewGeneratorStep1Route
  '/admin-advanced-interview-generator-step-2': typeof adminAdminAdminAdvancedInterviewGeneratorStep2Route
  '/admin-companies': typeof adminAdminAdminCompaniesRoute
  '/admin-create-interview-step-2': typeof adminAdminAdminCreateInterviewStep2Route
  '/admin-dashboard': typeof adminAdminAdminDashboardRoute
  '/admin-interview-from-scratch': typeof adminAdminAdminInterviewFromScratchRoute
  '/create-category': typeof adminAdminCreateCategoryRoute
  '/create-category-old': typeof adminAdminCreateCategoryOldRoute
  '/create-interview': typeof adminAdminCreateInterviewRoute
  '/create-technology': typeof adminAdminCreateTechnologyRoute
  '/invite': typeof adminAdminInviteRoute
  '/account-verified': typeof authAuthAccountVerifiedRoute
  '/confirm-email': typeof authAuthConfirmEmailRoute
  '/forgot-password': typeof authAuthForgotPasswordRoute
  '/login': typeof authAuthLoginRoute
  '/register': typeof authAuthRegisterRoute
  '/reset-password': typeof authAuthResetPasswordRoute
  '/credits': typeof dashboardDashboardCreditsRoute
  '/customize-interview': typeof dashboardDashboardCustomizeInterviewRoute
  '/history': typeof dashboardDashboardHistoryRoute
  '/job-description': typeof dashboardDashboardJobDescriptionRoute
  '/profile': typeof dashboardDashboardProfileRouteWithChildren
  '/technologies': typeof dashboardDashboardTechnologiesRoute
  '/create-interview-step1': typeof partnerPartnerCreateInterviewStep1Route
  '/create-interview-step2': typeof partnerPartnerCreateInterviewStep2Route
  '/created-interviews': typeof partnerPartnerCreatedInterviewsRoute
  '/interview-duration': typeof partnerPartnerInterviewDurationRoute
  '/interview-from-scratch': typeof partnerPartnerInterviewFromScratchRoute
  '/interview-genarator-step2': typeof partnerPartnerInterviewGenaratorStep2Route
  '/interview-generator-step1': typeof partnerPartnerInterviewGeneratorStep1Route
  '/interview-overview': typeof partnerPartnerInterviewOverviewRoute
  '/invite-user': typeof partnerPartnerInviteUserRoute
  '/partner-review-mode': typeof partnerPartnerPartnerReviewModeRoute
  '/question-selector': typeof partnerPartnerQuestionSelectorRoute
  '/review-mode': typeof partnerPartnerReviewModeRoute
  '/review-mode-old': typeof partnerPartnerReviewModeOldRoute
  '/single-interview': typeof partnerPartnerSingleInterviewRoute
  '/technology/$id': typeof adminAdminTechnologyIdRoute
  '/history-details/$id': typeof dashboardDashboardHistoryDetailsIdRoute
  '/profile/info': typeof dashboardDashboardProfileInfoRoute
  '/profile/password': typeof dashboardDashboardProfilePasswordRoute
  '/questions/$id': typeof dashboardDashboardQuestionsIdRoute
  '/results-overview/$id': typeof dashboardDashboardResultsOverviewIdRoute
  '/history-category-detail/$interviewId/$categoryId': typeof dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/(admin)': typeof adminRouteWithChildren
  '/(admin)/_admin': typeof adminAdminRouteWithChildren
  '/(auth)': typeof authRouteWithChildren
  '/(auth)/_auth': typeof authAuthRouteWithChildren
  '/(dashboard)': typeof dashboardRouteWithChildren
  '/(dashboard)/_dashboard': typeof dashboardDashboardRouteWithChildren
  '/(partner)': typeof partnerRouteWithChildren
  '/(partner)/_partner': typeof partnerPartnerRouteWithChildren
  '/(admin)/_admin/admin-advanced-interview-generator-step-1': typeof adminAdminAdminAdvancedInterviewGeneratorStep1Route
  '/(admin)/_admin/admin-advanced-interview-generator-step-2': typeof adminAdminAdminAdvancedInterviewGeneratorStep2Route
  '/(admin)/_admin/admin-companies': typeof adminAdminAdminCompaniesRoute
  '/(admin)/_admin/admin-create-interview-step-2': typeof adminAdminAdminCreateInterviewStep2Route
  '/(admin)/_admin/admin-dashboard': typeof adminAdminAdminDashboardRoute
  '/(admin)/_admin/admin-interview-from-scratch': typeof adminAdminAdminInterviewFromScratchRoute
  '/(admin)/_admin/create-category': typeof adminAdminCreateCategoryRoute
  '/(admin)/_admin/create-category-old': typeof adminAdminCreateCategoryOldRoute
  '/(admin)/_admin/create-interview': typeof adminAdminCreateInterviewRoute
  '/(admin)/_admin/create-technology': typeof adminAdminCreateTechnologyRoute
  '/(admin)/_admin/invite': typeof adminAdminInviteRoute
  '/(auth)/_auth/account-verified': typeof authAuthAccountVerifiedRoute
  '/(auth)/_auth/confirm-email': typeof authAuthConfirmEmailRoute
  '/(auth)/_auth/forgot-password': typeof authAuthForgotPasswordRoute
  '/(auth)/_auth/login': typeof authAuthLoginRoute
  '/(auth)/_auth/register': typeof authAuthRegisterRoute
  '/(auth)/_auth/reset-password': typeof authAuthResetPasswordRoute
  '/(dashboard)/_dashboard/credits': typeof dashboardDashboardCreditsRoute
  '/(dashboard)/_dashboard/customize-interview': typeof dashboardDashboardCustomizeInterviewRoute
  '/(dashboard)/_dashboard/history': typeof dashboardDashboardHistoryRoute
  '/(dashboard)/_dashboard/job-description': typeof dashboardDashboardJobDescriptionRoute
  '/(dashboard)/_dashboard/profile': typeof dashboardDashboardProfileRouteWithChildren
  '/(dashboard)/_dashboard/technologies': typeof dashboardDashboardTechnologiesRoute
  '/(partner)/_partner/create-interview-step1': typeof partnerPartnerCreateInterviewStep1Route
  '/(partner)/_partner/create-interview-step2': typeof partnerPartnerCreateInterviewStep2Route
  '/(partner)/_partner/created-interviews': typeof partnerPartnerCreatedInterviewsRoute
  '/(partner)/_partner/interview-duration': typeof partnerPartnerInterviewDurationRoute
  '/(partner)/_partner/interview-from-scratch': typeof partnerPartnerInterviewFromScratchRoute
  '/(partner)/_partner/interview-genarator-step2': typeof partnerPartnerInterviewGenaratorStep2Route
  '/(partner)/_partner/interview-generator-step1': typeof partnerPartnerInterviewGeneratorStep1Route
  '/(partner)/_partner/interview-overview': typeof partnerPartnerInterviewOverviewRoute
  '/(partner)/_partner/invite-user': typeof partnerPartnerInviteUserRoute
  '/(partner)/_partner/partner-review-mode': typeof partnerPartnerPartnerReviewModeRoute
  '/(partner)/_partner/question-selector': typeof partnerPartnerQuestionSelectorRoute
  '/(partner)/_partner/review-mode': typeof partnerPartnerReviewModeRoute
  '/(partner)/_partner/review-mode-old': typeof partnerPartnerReviewModeOldRoute
  '/(partner)/_partner/single-interview': typeof partnerPartnerSingleInterviewRoute
  '/(admin)/_admin/technology/$id': typeof adminAdminTechnologyIdRoute
  '/(dashboard)/_dashboard/history-details/$id': typeof dashboardDashboardHistoryDetailsIdRoute
  '/(dashboard)/_dashboard/profile/info': typeof dashboardDashboardProfileInfoRoute
  '/(dashboard)/_dashboard/profile/password': typeof dashboardDashboardProfilePasswordRoute
  '/(dashboard)/_dashboard/questions/$id': typeof dashboardDashboardQuestionsIdRoute
  '/(dashboard)/_dashboard/results-overview/$id': typeof dashboardDashboardResultsOverviewIdRoute
  '/(dashboard)/_dashboard/history-category-detail/$interviewId/$categoryId': typeof dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-advanced-interview-generator-step-1'
    | '/admin-advanced-interview-generator-step-2'
    | '/admin-companies'
    | '/admin-create-interview-step-2'
    | '/admin-dashboard'
    | '/admin-interview-from-scratch'
    | '/create-category'
    | '/create-category-old'
    | '/create-interview'
    | '/create-technology'
    | '/invite'
    | '/account-verified'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/credits'
    | '/customize-interview'
    | '/history'
    | '/job-description'
    | '/profile'
    | '/technologies'
    | '/create-interview-step1'
    | '/create-interview-step2'
    | '/created-interviews'
    | '/interview-duration'
    | '/interview-from-scratch'
    | '/interview-genarator-step2'
    | '/interview-generator-step1'
    | '/interview-overview'
    | '/invite-user'
    | '/partner-review-mode'
    | '/question-selector'
    | '/review-mode'
    | '/review-mode-old'
    | '/single-interview'
    | '/technology/$id'
    | '/history-details/$id'
    | '/profile/info'
    | '/profile/password'
    | '/questions/$id'
    | '/results-overview/$id'
    | '/history-category-detail/$interviewId/$categoryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-advanced-interview-generator-step-1'
    | '/admin-advanced-interview-generator-step-2'
    | '/admin-companies'
    | '/admin-create-interview-step-2'
    | '/admin-dashboard'
    | '/admin-interview-from-scratch'
    | '/create-category'
    | '/create-category-old'
    | '/create-interview'
    | '/create-technology'
    | '/invite'
    | '/account-verified'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/credits'
    | '/customize-interview'
    | '/history'
    | '/job-description'
    | '/profile'
    | '/technologies'
    | '/create-interview-step1'
    | '/create-interview-step2'
    | '/created-interviews'
    | '/interview-duration'
    | '/interview-from-scratch'
    | '/interview-genarator-step2'
    | '/interview-generator-step1'
    | '/interview-overview'
    | '/invite-user'
    | '/partner-review-mode'
    | '/question-selector'
    | '/review-mode'
    | '/review-mode-old'
    | '/single-interview'
    | '/technology/$id'
    | '/history-details/$id'
    | '/profile/info'
    | '/profile/password'
    | '/questions/$id'
    | '/results-overview/$id'
    | '/history-category-detail/$interviewId/$categoryId'
  id:
    | '__root__'
    | '/'
    | '/(admin)'
    | '/(admin)/_admin'
    | '/(auth)'
    | '/(auth)/_auth'
    | '/(dashboard)'
    | '/(dashboard)/_dashboard'
    | '/(partner)'
    | '/(partner)/_partner'
    | '/(admin)/_admin/admin-advanced-interview-generator-step-1'
    | '/(admin)/_admin/admin-advanced-interview-generator-step-2'
    | '/(admin)/_admin/admin-companies'
    | '/(admin)/_admin/admin-create-interview-step-2'
    | '/(admin)/_admin/admin-dashboard'
    | '/(admin)/_admin/admin-interview-from-scratch'
    | '/(admin)/_admin/create-category'
    | '/(admin)/_admin/create-category-old'
    | '/(admin)/_admin/create-interview'
    | '/(admin)/_admin/create-technology'
    | '/(admin)/_admin/invite'
    | '/(auth)/_auth/account-verified'
    | '/(auth)/_auth/confirm-email'
    | '/(auth)/_auth/forgot-password'
    | '/(auth)/_auth/login'
    | '/(auth)/_auth/register'
    | '/(auth)/_auth/reset-password'
    | '/(dashboard)/_dashboard/credits'
    | '/(dashboard)/_dashboard/customize-interview'
    | '/(dashboard)/_dashboard/history'
    | '/(dashboard)/_dashboard/job-description'
    | '/(dashboard)/_dashboard/profile'
    | '/(dashboard)/_dashboard/technologies'
    | '/(partner)/_partner/create-interview-step1'
    | '/(partner)/_partner/create-interview-step2'
    | '/(partner)/_partner/created-interviews'
    | '/(partner)/_partner/interview-duration'
    | '/(partner)/_partner/interview-from-scratch'
    | '/(partner)/_partner/interview-genarator-step2'
    | '/(partner)/_partner/interview-generator-step1'
    | '/(partner)/_partner/interview-overview'
    | '/(partner)/_partner/invite-user'
    | '/(partner)/_partner/partner-review-mode'
    | '/(partner)/_partner/question-selector'
    | '/(partner)/_partner/review-mode'
    | '/(partner)/_partner/review-mode-old'
    | '/(partner)/_partner/single-interview'
    | '/(admin)/_admin/technology/$id'
    | '/(dashboard)/_dashboard/history-details/$id'
    | '/(dashboard)/_dashboard/profile/info'
    | '/(dashboard)/_dashboard/profile/password'
    | '/(dashboard)/_dashboard/questions/$id'
    | '/(dashboard)/_dashboard/results-overview/$id'
    | '/(dashboard)/_dashboard/history-category-detail/$interviewId/$categoryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  adminRoute: typeof adminRouteWithChildren
  authRoute: typeof authRouteWithChildren
  dashboardRoute: typeof dashboardRouteWithChildren
  partnerRoute: typeof partnerRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(partner)': {
      id: '/(partner)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof partnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)': {
      id: '/(dashboard)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)': {
      id: '/(admin)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof adminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(partner)/_partner': {
      id: '/(partner)/_partner'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof partnerPartnerRouteImport
      parentRoute: typeof partnerRoute
    }
    '/(dashboard)/_dashboard': {
      id: '/(dashboard)/_dashboard'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardDashboardRouteImport
      parentRoute: typeof dashboardRoute
    }
    '/(auth)/_auth': {
      id: '/(auth)/_auth'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof authRoute
    }
    '/(admin)/_admin': {
      id: '/(admin)/_admin'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof adminAdminRouteImport
      parentRoute: typeof adminRoute
    }
    '/(partner)/_partner/single-interview': {
      id: '/(partner)/_partner/single-interview'
      path: '/single-interview'
      fullPath: '/single-interview'
      preLoaderRoute: typeof partnerPartnerSingleInterviewRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/review-mode-old': {
      id: '/(partner)/_partner/review-mode-old'
      path: '/review-mode-old'
      fullPath: '/review-mode-old'
      preLoaderRoute: typeof partnerPartnerReviewModeOldRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/review-mode': {
      id: '/(partner)/_partner/review-mode'
      path: '/review-mode'
      fullPath: '/review-mode'
      preLoaderRoute: typeof partnerPartnerReviewModeRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/question-selector': {
      id: '/(partner)/_partner/question-selector'
      path: '/question-selector'
      fullPath: '/question-selector'
      preLoaderRoute: typeof partnerPartnerQuestionSelectorRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/partner-review-mode': {
      id: '/(partner)/_partner/partner-review-mode'
      path: '/partner-review-mode'
      fullPath: '/partner-review-mode'
      preLoaderRoute: typeof partnerPartnerPartnerReviewModeRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/invite-user': {
      id: '/(partner)/_partner/invite-user'
      path: '/invite-user'
      fullPath: '/invite-user'
      preLoaderRoute: typeof partnerPartnerInviteUserRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/interview-overview': {
      id: '/(partner)/_partner/interview-overview'
      path: '/interview-overview'
      fullPath: '/interview-overview'
      preLoaderRoute: typeof partnerPartnerInterviewOverviewRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/interview-generator-step1': {
      id: '/(partner)/_partner/interview-generator-step1'
      path: '/interview-generator-step1'
      fullPath: '/interview-generator-step1'
      preLoaderRoute: typeof partnerPartnerInterviewGeneratorStep1RouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/interview-genarator-step2': {
      id: '/(partner)/_partner/interview-genarator-step2'
      path: '/interview-genarator-step2'
      fullPath: '/interview-genarator-step2'
      preLoaderRoute: typeof partnerPartnerInterviewGenaratorStep2RouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/interview-from-scratch': {
      id: '/(partner)/_partner/interview-from-scratch'
      path: '/interview-from-scratch'
      fullPath: '/interview-from-scratch'
      preLoaderRoute: typeof partnerPartnerInterviewFromScratchRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/interview-duration': {
      id: '/(partner)/_partner/interview-duration'
      path: '/interview-duration'
      fullPath: '/interview-duration'
      preLoaderRoute: typeof partnerPartnerInterviewDurationRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/created-interviews': {
      id: '/(partner)/_partner/created-interviews'
      path: '/created-interviews'
      fullPath: '/created-interviews'
      preLoaderRoute: typeof partnerPartnerCreatedInterviewsRouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/create-interview-step2': {
      id: '/(partner)/_partner/create-interview-step2'
      path: '/create-interview-step2'
      fullPath: '/create-interview-step2'
      preLoaderRoute: typeof partnerPartnerCreateInterviewStep2RouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(partner)/_partner/create-interview-step1': {
      id: '/(partner)/_partner/create-interview-step1'
      path: '/create-interview-step1'
      fullPath: '/create-interview-step1'
      preLoaderRoute: typeof partnerPartnerCreateInterviewStep1RouteImport
      parentRoute: typeof partnerPartnerRoute
    }
    '/(dashboard)/_dashboard/technologies': {
      id: '/(dashboard)/_dashboard/technologies'
      path: '/technologies'
      fullPath: '/technologies'
      preLoaderRoute: typeof dashboardDashboardTechnologiesRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/profile': {
      id: '/(dashboard)/_dashboard/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof dashboardDashboardProfileRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/job-description': {
      id: '/(dashboard)/_dashboard/job-description'
      path: '/job-description'
      fullPath: '/job-description'
      preLoaderRoute: typeof dashboardDashboardJobDescriptionRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/history': {
      id: '/(dashboard)/_dashboard/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof dashboardDashboardHistoryRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/customize-interview': {
      id: '/(dashboard)/_dashboard/customize-interview'
      path: '/customize-interview'
      fullPath: '/customize-interview'
      preLoaderRoute: typeof dashboardDashboardCustomizeInterviewRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/credits': {
      id: '/(dashboard)/_dashboard/credits'
      path: '/credits'
      fullPath: '/credits'
      preLoaderRoute: typeof dashboardDashboardCreditsRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(auth)/_auth/reset-password': {
      id: '/(auth)/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authAuthResetPasswordRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/register': {
      id: '/(auth)/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authAuthRegisterRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/login': {
      id: '/(auth)/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authAuthLoginRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/forgot-password': {
      id: '/(auth)/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authAuthForgotPasswordRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/confirm-email': {
      id: '/(auth)/_auth/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof authAuthConfirmEmailRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(auth)/_auth/account-verified': {
      id: '/(auth)/_auth/account-verified'
      path: '/account-verified'
      fullPath: '/account-verified'
      preLoaderRoute: typeof authAuthAccountVerifiedRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(admin)/_admin/invite': {
      id: '/(admin)/_admin/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof adminAdminInviteRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/create-technology': {
      id: '/(admin)/_admin/create-technology'
      path: '/create-technology'
      fullPath: '/create-technology'
      preLoaderRoute: typeof adminAdminCreateTechnologyRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/create-interview': {
      id: '/(admin)/_admin/create-interview'
      path: '/create-interview'
      fullPath: '/create-interview'
      preLoaderRoute: typeof adminAdminCreateInterviewRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/create-category-old': {
      id: '/(admin)/_admin/create-category-old'
      path: '/create-category-old'
      fullPath: '/create-category-old'
      preLoaderRoute: typeof adminAdminCreateCategoryOldRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/create-category': {
      id: '/(admin)/_admin/create-category'
      path: '/create-category'
      fullPath: '/create-category'
      preLoaderRoute: typeof adminAdminCreateCategoryRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/admin-interview-from-scratch': {
      id: '/(admin)/_admin/admin-interview-from-scratch'
      path: '/admin-interview-from-scratch'
      fullPath: '/admin-interview-from-scratch'
      preLoaderRoute: typeof adminAdminAdminInterviewFromScratchRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/admin-dashboard': {
      id: '/(admin)/_admin/admin-dashboard'
      path: '/admin-dashboard'
      fullPath: '/admin-dashboard'
      preLoaderRoute: typeof adminAdminAdminDashboardRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/admin-create-interview-step-2': {
      id: '/(admin)/_admin/admin-create-interview-step-2'
      path: '/admin-create-interview-step-2'
      fullPath: '/admin-create-interview-step-2'
      preLoaderRoute: typeof adminAdminAdminCreateInterviewStep2RouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/admin-companies': {
      id: '/(admin)/_admin/admin-companies'
      path: '/admin-companies'
      fullPath: '/admin-companies'
      preLoaderRoute: typeof adminAdminAdminCompaniesRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/admin-advanced-interview-generator-step-2': {
      id: '/(admin)/_admin/admin-advanced-interview-generator-step-2'
      path: '/admin-advanced-interview-generator-step-2'
      fullPath: '/admin-advanced-interview-generator-step-2'
      preLoaderRoute: typeof adminAdminAdminAdvancedInterviewGeneratorStep2RouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(admin)/_admin/admin-advanced-interview-generator-step-1': {
      id: '/(admin)/_admin/admin-advanced-interview-generator-step-1'
      path: '/admin-advanced-interview-generator-step-1'
      fullPath: '/admin-advanced-interview-generator-step-1'
      preLoaderRoute: typeof adminAdminAdminAdvancedInterviewGeneratorStep1RouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(dashboard)/_dashboard/results-overview/$id': {
      id: '/(dashboard)/_dashboard/results-overview/$id'
      path: '/results-overview/$id'
      fullPath: '/results-overview/$id'
      preLoaderRoute: typeof dashboardDashboardResultsOverviewIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/questions/$id': {
      id: '/(dashboard)/_dashboard/questions/$id'
      path: '/questions/$id'
      fullPath: '/questions/$id'
      preLoaderRoute: typeof dashboardDashboardQuestionsIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/profile/password': {
      id: '/(dashboard)/_dashboard/profile/password'
      path: '/password'
      fullPath: '/profile/password'
      preLoaderRoute: typeof dashboardDashboardProfilePasswordRouteImport
      parentRoute: typeof dashboardDashboardProfileRoute
    }
    '/(dashboard)/_dashboard/profile/info': {
      id: '/(dashboard)/_dashboard/profile/info'
      path: '/info'
      fullPath: '/profile/info'
      preLoaderRoute: typeof dashboardDashboardProfileInfoRouteImport
      parentRoute: typeof dashboardDashboardProfileRoute
    }
    '/(dashboard)/_dashboard/history-details/$id': {
      id: '/(dashboard)/_dashboard/history-details/$id'
      path: '/history-details/$id'
      fullPath: '/history-details/$id'
      preLoaderRoute: typeof dashboardDashboardHistoryDetailsIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(admin)/_admin/technology/$id': {
      id: '/(admin)/_admin/technology/$id'
      path: '/technology/$id'
      fullPath: '/technology/$id'
      preLoaderRoute: typeof adminAdminTechnologyIdRouteImport
      parentRoute: typeof adminAdminRoute
    }
    '/(dashboard)/_dashboard/history-category-detail/$interviewId/$categoryId': {
      id: '/(dashboard)/_dashboard/history-category-detail/$interviewId/$categoryId'
      path: '/history-category-detail/$interviewId/$categoryId'
      fullPath: '/history-category-detail/$interviewId/$categoryId'
      preLoaderRoute: typeof dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
  }
}

interface adminAdminRouteChildren {
  adminAdminAdminAdvancedInterviewGeneratorStep1Route: typeof adminAdminAdminAdvancedInterviewGeneratorStep1Route
  adminAdminAdminAdvancedInterviewGeneratorStep2Route: typeof adminAdminAdminAdvancedInterviewGeneratorStep2Route
  adminAdminAdminCompaniesRoute: typeof adminAdminAdminCompaniesRoute
  adminAdminAdminCreateInterviewStep2Route: typeof adminAdminAdminCreateInterviewStep2Route
  adminAdminAdminDashboardRoute: typeof adminAdminAdminDashboardRoute
  adminAdminAdminInterviewFromScratchRoute: typeof adminAdminAdminInterviewFromScratchRoute
  adminAdminCreateCategoryRoute: typeof adminAdminCreateCategoryRoute
  adminAdminCreateCategoryOldRoute: typeof adminAdminCreateCategoryOldRoute
  adminAdminCreateInterviewRoute: typeof adminAdminCreateInterviewRoute
  adminAdminCreateTechnologyRoute: typeof adminAdminCreateTechnologyRoute
  adminAdminInviteRoute: typeof adminAdminInviteRoute
  adminAdminTechnologyIdRoute: typeof adminAdminTechnologyIdRoute
}

const adminAdminRouteChildren: adminAdminRouteChildren = {
  adminAdminAdminAdvancedInterviewGeneratorStep1Route:
    adminAdminAdminAdvancedInterviewGeneratorStep1Route,
  adminAdminAdminAdvancedInterviewGeneratorStep2Route:
    adminAdminAdminAdvancedInterviewGeneratorStep2Route,
  adminAdminAdminCompaniesRoute: adminAdminAdminCompaniesRoute,
  adminAdminAdminCreateInterviewStep2Route:
    adminAdminAdminCreateInterviewStep2Route,
  adminAdminAdminDashboardRoute: adminAdminAdminDashboardRoute,
  adminAdminAdminInterviewFromScratchRoute:
    adminAdminAdminInterviewFromScratchRoute,
  adminAdminCreateCategoryRoute: adminAdminCreateCategoryRoute,
  adminAdminCreateCategoryOldRoute: adminAdminCreateCategoryOldRoute,
  adminAdminCreateInterviewRoute: adminAdminCreateInterviewRoute,
  adminAdminCreateTechnologyRoute: adminAdminCreateTechnologyRoute,
  adminAdminInviteRoute: adminAdminInviteRoute,
  adminAdminTechnologyIdRoute: adminAdminTechnologyIdRoute,
}

const adminAdminRouteWithChildren = adminAdminRoute._addFileChildren(
  adminAdminRouteChildren,
)

interface adminRouteChildren {
  adminAdminRoute: typeof adminAdminRouteWithChildren
}

const adminRouteChildren: adminRouteChildren = {
  adminAdminRoute: adminAdminRouteWithChildren,
}

const adminRouteWithChildren = adminRoute._addFileChildren(adminRouteChildren)

interface authAuthRouteChildren {
  authAuthAccountVerifiedRoute: typeof authAuthAccountVerifiedRoute
  authAuthConfirmEmailRoute: typeof authAuthConfirmEmailRoute
  authAuthForgotPasswordRoute: typeof authAuthForgotPasswordRoute
  authAuthLoginRoute: typeof authAuthLoginRoute
  authAuthRegisterRoute: typeof authAuthRegisterRoute
  authAuthResetPasswordRoute: typeof authAuthResetPasswordRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthAccountVerifiedRoute: authAuthAccountVerifiedRoute,
  authAuthConfirmEmailRoute: authAuthConfirmEmailRoute,
  authAuthForgotPasswordRoute: authAuthForgotPasswordRoute,
  authAuthLoginRoute: authAuthLoginRoute,
  authAuthRegisterRoute: authAuthRegisterRoute,
  authAuthResetPasswordRoute: authAuthResetPasswordRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

interface authRouteChildren {
  authAuthRoute: typeof authAuthRouteWithChildren
}

const authRouteChildren: authRouteChildren = {
  authAuthRoute: authAuthRouteWithChildren,
}

const authRouteWithChildren = authRoute._addFileChildren(authRouteChildren)

interface dashboardDashboardProfileRouteChildren {
  dashboardDashboardProfileInfoRoute: typeof dashboardDashboardProfileInfoRoute
  dashboardDashboardProfilePasswordRoute: typeof dashboardDashboardProfilePasswordRoute
}

const dashboardDashboardProfileRouteChildren: dashboardDashboardProfileRouteChildren =
  {
    dashboardDashboardProfileInfoRoute: dashboardDashboardProfileInfoRoute,
    dashboardDashboardProfilePasswordRoute:
      dashboardDashboardProfilePasswordRoute,
  }

const dashboardDashboardProfileRouteWithChildren =
  dashboardDashboardProfileRoute._addFileChildren(
    dashboardDashboardProfileRouteChildren,
  )

interface dashboardDashboardRouteChildren {
  dashboardDashboardCreditsRoute: typeof dashboardDashboardCreditsRoute
  dashboardDashboardCustomizeInterviewRoute: typeof dashboardDashboardCustomizeInterviewRoute
  dashboardDashboardHistoryRoute: typeof dashboardDashboardHistoryRoute
  dashboardDashboardJobDescriptionRoute: typeof dashboardDashboardJobDescriptionRoute
  dashboardDashboardProfileRoute: typeof dashboardDashboardProfileRouteWithChildren
  dashboardDashboardTechnologiesRoute: typeof dashboardDashboardTechnologiesRoute
  dashboardDashboardHistoryDetailsIdRoute: typeof dashboardDashboardHistoryDetailsIdRoute
  dashboardDashboardQuestionsIdRoute: typeof dashboardDashboardQuestionsIdRoute
  dashboardDashboardResultsOverviewIdRoute: typeof dashboardDashboardResultsOverviewIdRoute
  dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute: typeof dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute
}

const dashboardDashboardRouteChildren: dashboardDashboardRouteChildren = {
  dashboardDashboardCreditsRoute: dashboardDashboardCreditsRoute,
  dashboardDashboardCustomizeInterviewRoute:
    dashboardDashboardCustomizeInterviewRoute,
  dashboardDashboardHistoryRoute: dashboardDashboardHistoryRoute,
  dashboardDashboardJobDescriptionRoute: dashboardDashboardJobDescriptionRoute,
  dashboardDashboardProfileRoute: dashboardDashboardProfileRouteWithChildren,
  dashboardDashboardTechnologiesRoute: dashboardDashboardTechnologiesRoute,
  dashboardDashboardHistoryDetailsIdRoute:
    dashboardDashboardHistoryDetailsIdRoute,
  dashboardDashboardQuestionsIdRoute: dashboardDashboardQuestionsIdRoute,
  dashboardDashboardResultsOverviewIdRoute:
    dashboardDashboardResultsOverviewIdRoute,
  dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute:
    dashboardDashboardHistoryCategoryDetailInterviewIdCategoryIdRoute,
}

const dashboardDashboardRouteWithChildren =
  dashboardDashboardRoute._addFileChildren(dashboardDashboardRouteChildren)

interface dashboardRouteChildren {
  dashboardDashboardRoute: typeof dashboardDashboardRouteWithChildren
}

const dashboardRouteChildren: dashboardRouteChildren = {
  dashboardDashboardRoute: dashboardDashboardRouteWithChildren,
}

const dashboardRouteWithChildren = dashboardRoute._addFileChildren(
  dashboardRouteChildren,
)

interface partnerPartnerRouteChildren {
  partnerPartnerCreateInterviewStep1Route: typeof partnerPartnerCreateInterviewStep1Route
  partnerPartnerCreateInterviewStep2Route: typeof partnerPartnerCreateInterviewStep2Route
  partnerPartnerCreatedInterviewsRoute: typeof partnerPartnerCreatedInterviewsRoute
  partnerPartnerInterviewDurationRoute: typeof partnerPartnerInterviewDurationRoute
  partnerPartnerInterviewFromScratchRoute: typeof partnerPartnerInterviewFromScratchRoute
  partnerPartnerInterviewGenaratorStep2Route: typeof partnerPartnerInterviewGenaratorStep2Route
  partnerPartnerInterviewGeneratorStep1Route: typeof partnerPartnerInterviewGeneratorStep1Route
  partnerPartnerInterviewOverviewRoute: typeof partnerPartnerInterviewOverviewRoute
  partnerPartnerInviteUserRoute: typeof partnerPartnerInviteUserRoute
  partnerPartnerPartnerReviewModeRoute: typeof partnerPartnerPartnerReviewModeRoute
  partnerPartnerQuestionSelectorRoute: typeof partnerPartnerQuestionSelectorRoute
  partnerPartnerReviewModeRoute: typeof partnerPartnerReviewModeRoute
  partnerPartnerReviewModeOldRoute: typeof partnerPartnerReviewModeOldRoute
  partnerPartnerSingleInterviewRoute: typeof partnerPartnerSingleInterviewRoute
}

const partnerPartnerRouteChildren: partnerPartnerRouteChildren = {
  partnerPartnerCreateInterviewStep1Route:
    partnerPartnerCreateInterviewStep1Route,
  partnerPartnerCreateInterviewStep2Route:
    partnerPartnerCreateInterviewStep2Route,
  partnerPartnerCreatedInterviewsRoute: partnerPartnerCreatedInterviewsRoute,
  partnerPartnerInterviewDurationRoute: partnerPartnerInterviewDurationRoute,
  partnerPartnerInterviewFromScratchRoute:
    partnerPartnerInterviewFromScratchRoute,
  partnerPartnerInterviewGenaratorStep2Route:
    partnerPartnerInterviewGenaratorStep2Route,
  partnerPartnerInterviewGeneratorStep1Route:
    partnerPartnerInterviewGeneratorStep1Route,
  partnerPartnerInterviewOverviewRoute: partnerPartnerInterviewOverviewRoute,
  partnerPartnerInviteUserRoute: partnerPartnerInviteUserRoute,
  partnerPartnerPartnerReviewModeRoute: partnerPartnerPartnerReviewModeRoute,
  partnerPartnerQuestionSelectorRoute: partnerPartnerQuestionSelectorRoute,
  partnerPartnerReviewModeRoute: partnerPartnerReviewModeRoute,
  partnerPartnerReviewModeOldRoute: partnerPartnerReviewModeOldRoute,
  partnerPartnerSingleInterviewRoute: partnerPartnerSingleInterviewRoute,
}

const partnerPartnerRouteWithChildren = partnerPartnerRoute._addFileChildren(
  partnerPartnerRouteChildren,
)

interface partnerRouteChildren {
  partnerPartnerRoute: typeof partnerPartnerRouteWithChildren
}

const partnerRouteChildren: partnerRouteChildren = {
  partnerPartnerRoute: partnerPartnerRouteWithChildren,
}

const partnerRouteWithChildren =
  partnerRoute._addFileChildren(partnerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  adminRoute: adminRouteWithChildren,
  authRoute: authRouteWithChildren,
  dashboardRoute: dashboardRouteWithChildren,
  partnerRoute: partnerRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
